export const blacklist = [
  {
    rank: 1,
    name: "铁砧竞技",
    team: "足球 · 甲级联赛",
    categoryId: "football",
    eventId: "evt-001",
    score: 92.4,
    metrics: { form: 93, defense: 90, discipline: 78, efficiency: 88 },
    comment: "下半场完全失去中场控制，后防线协防漏洞被反复利用，客场状态持续走低。",
  },
  {
    rank: 2,
    name: "极地车队",
    team: "赛车 · 耐力赛",
    categoryId: "racing",
    eventId: "evt-005",
    score: 90.8,
    metrics: { form: 88, defense: 92, discipline: 85, efficiency: 91 },
    comment: "两次超时进站累计损失超 90 秒，轮胎策略保守，团队沟通出现明显失误。",
  },
  {
    rank: 3,
    name: "雷霆拳馆",
    team: "拳击 · 中量级",
    categoryId: "boxing",
    eventId: "evt-009",
    score: 89.1,
    metrics: { form: 90, defense: 94, discipline: 80, efficiency: 86 },
    comment: "前手拳防守动作不到位，第三回合被抓住空档直接告负，防守反应明显迟缓。",
  },
  {
    rank: 4,
    name: "雷霆战队",
    team: "电竞 · 全球冠军赛",
    categoryId: "esports",
    eventId: "evt-008",
    score: 87.6,
    metrics: { form: 89, defense: 84, discipline: 82, efficiency: 88 },
    comment: "地图资源控制全面落后，前期资源取舍混乱，团队配合松散。",
  },
  {
    rank: 5,
    name: "雾都联",
    team: "足球 · 甲级联赛",
    categoryId: "football",
    eventId: "evt-002",
    score: 86.3,
    metrics: { form: 87, defense: 80, discipline: 84, efficiency: 93 },
    comment: "全场被动依靠门将救险，前场配合缺乏默契，进攻效率创赛季新低。",
  },
  {
    rank: 6,
    name: "星辰战队",
    team: "电竞 · 全球冠军赛",
    categoryId: "esports",
    eventId: "evt-007",
    score: 84.9,
    metrics: { form: 86, defense: 83, discipline: 79, efficiency: 84 },
    comment: "关键局决策冒进，领先局面下连续强行开团，直接让出胜势。",
  },
  {
    rank: 7,
    name: "赤焰",
    team: "篮球 · 职业联赛",
    categoryId: "basketball",
    eventId: "evt-003",
    score: 83.2,
    metrics: { form: 85, defense: 81, discipline: 78, efficiency: 87 },
    comment: "末节单节命中率跌至 27%，失误数达 7 次，关键球处理过度依赖单打。",
  },
  {
    rank: 8,
    name: "白鲸 FC",
    team: "足球 · 甲级联赛",
    categoryId: "football",
    eventId: "evt-002",
    score: 81.5,
    metrics: { form: 76, defense: 74, discipline: 82, efficiency: 90 },
    comment: "控球率高达 64% 却得势不得分，最后一传选择过于保守。",
  },
  {
    rank: 9,
    name: "北极星车队",
    team: "赛车 · 新秀杯",
    categoryId: "racing",
    eventId: "evt-006",
    score: 79.8,
    metrics: { form: 77, defense: 79, discipline: 83, efficiency: 80 },
    comment: "节奏稳定但极限圈速不足，街道赛道适应能力偏弱。",
  },
  {
    rank: 10,
    name: "城市跑团联队",
    team: "综合 · 马拉松",
    categoryId: "other",
    eventId: "evt-011",
    score: 77.4,
    metrics: { form: 74, defense: 76, discipline: 80, efficiency: 78 },
    comment: "团队氛围出色但精英选手厚度不足，后程配速掉速明显。",
  },
];